export default function HowDidCoRATESStart() {
  return (
    <section className='border-y border-gray-100 bg-linear-to-b from-white to-gray-50'>
      <div className='mx-auto max-w-4xl px-6 py-20'>
        <h2 className='mb-8 text-2xl font-bold text-gray-900 md:text-3xl'>
          How Did CoRATES Get Started?
        </h2>

        <div className='rounded-2xl border border-gray-100 bg-white p-8 shadow-sm md:p-10'>
          <div className='flex flex-col gap-6 leading-relaxed text-gray-600'>
            <p>
              CoRATES began with a problem familiar to anyone involved in evidence synthesis: the
              study appraisal process was far more cumbersome than it needed to be. Managing PDF or
              Word checklists, juggling multiple spreadsheets, applying complex scoring rules, and
              relying on separate applications for data entry, documentation and visualization made
              the workflow fragmented, time-consuming, and prone to error.
            </p>
            <p>
              Brandy, an evidence synthesis expert who had experienced these challenges firsthand
              across dozens of systematic reviews, knew there had to be a better way. She not only
              wanted to streamline and automate the process, but wanted to create a tool that
              genuinely supports rigorous study appraisal and makes it easier for others to conduct
              high-quality assessments. To build such a platform, she turned to Jacob, a software
              engineer and data scientist.
            </p>
            <p>
              Together, they combined methodological expertise with modern software design to create
              CoRATES, a platform intentionally built to support rigorous evidence appraisal while
              making the process more organized, transparent, and manageable. Their goal was not
              only to reduce the many pain points of conducting quality and risk of bias
              assessments, but to build a tool grounded in rigor, supported by thoughtful design,
              and genuinely useful to researchers, clinicians, educators, and students.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
